import React from "react";
import { translate } from "../Services/translation";

const MiniCart = ({
    quantity,
    orderTotal,
    checkoutUrl,
    showInfo,
    toggle,
    isCheckoutPage,
    isAnonymousUser,
}) => (
    <>
        {isAnonymousUser === "True" ? null : (
            <div className="cart cart--mini">
                <a
                    href="#"
                    className={`cart__link--block ${
                        isCheckoutPage ? "active" : ""
                    }`}
                    onClick={() => toggle()}
                >
                    <span className="cart-icon-container">
                        {quantity > 0 && (
                            <span className="cart-icon-container__indicator">
                                {quantity}
                            </span>
                        )}
                        <svg className="cart__icon">
                            <use href="/ui/images/kimido/sprite.svg#cart"></use>
                        </svg>
                    </span>
                    {/* <span className="cart__title">{ translate('minicart.checkout') }</span> */}
                </a>
                <div
                    className={`cart__info ${
                        !showInfo ? "cart__info--hidden" : ""
                    }`}
                >
                    <span
                        className="cart__close-button"
                        onClick={() => toggle()}
                    ></span>
                    <p className="cart__info-row">
                        {quantity} {translate("minicart.numberofproduct")}
                    </p>
                    <p className="cart__info-row">
                        <b>{translate("minicart.total")}</b> {orderTotal}
                    </p>
                    <a
                        href={checkoutUrl}
                        className="btn btn--salad btn__block cart__checkout-button"
                    >
                        {translate("minicart.checkout")}
                    </a>
                </div>
            </div>
        )}
    </>
);

export default MiniCart;
